// @flow
import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { Button } from 'freemium-ui';
import IncidentCard from './incidentCard';
import { useTranslation } from 'react-i18next';

type Props = {
  values: any,
  incidentType: any,
  activeAccount: any,
  currentAccountMeta: any
};

const IncidentPreview = ({
  incidentType,
  values,
  activeAccount,
  currentAccountMeta,
  components,
  componentGroups
}: Props) => {
  const { t } = useTranslation();
  const { title, logo_url } =
    currentAccountMeta && currentAccountMeta.basic_branding_data;

  return (
    <Box>
      <PreviewHeader alignItems="center" justifyContent="space-between">
        {logo_url ? (
          <img src={logo_url} alt="logo" />
        ) : (
          <h2 className="">{title}</h2>
        )}
        <Box>
          <Button disabled type="secondary">
            {t('components.incidentPreview.subscribe')}
          </Button>
        </Box>
      </PreviewHeader>
      <IncidentCard
        currentAccount={activeAccount}
        incidentDetails={values}
        incidentType={incidentType}
        components={components}
        componentGroups={componentGroups}
      />
    </Box>
  );
};

export default IncidentPreview;

const PreviewHeader = styled(Flex)`
  padding: 18px 32px 12px 32px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);

  h2 {
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    /* text-transform: capitalise; */
  }
  img {
    height: 45px;
    width: auto;
    box-sizing: border-box;
  }
`;
